import styled from "styled-components";

export const Rect = styled.rect`
    stroke: ${(props) => props.color};
`;

export const Circle = styled.circle`
    stroke: ${(props) => props.color};
    fill: ${(props) => props.fill};
`;

export const Icon = styled.svg`
    fill: none;
    &:hover {
        ${Circle} {
            fill: ${(props) =>
                props.hover && !props.disabled
                    ? props.circleFillHoverColor
                    : props.circleFillColor};
            stroke: ${(props) =>
                props.hover && !props.disabled
                    ? props.circleStrokeHoverColor
                    : props.circleStrokeColor};
        }
        ${Rect} {
            stroke: ${(props) =>
                props.hover && !props.disabled
                    ? props.rectStrokeHoverColor
                    : props.rectStrokeColor};
                    stroke: ${(props) =>
                        props.disabled && globalThis.config.colors.gray4};
        }
    }
    ${Rect} {
                stroke: ${(props) =>
                    props.disabled && globalThis.config.colors.gray4};

    }
    cursor:${(props) => (props.disabled ? "auto" : "pointer")};,
`;
